<script setup>
import { computed, onMounted } from 'vue'
import { storeToRefs } from "pinia";
import { useWizardStore } from './stores/WizardStore';
import Step1 from './components/Step1.vue';
import Step2 from './components/Step2.vue';
import Step3 from './components/Step3.vue';
import Step4 from './components/Step4.vue';
import Result from './components/Result.vue';
import mockSettings from './stores/mockSettings';

useWizardStore();
const store = useWizardStore()
const { showResults, inited, errorMessages } = storeToRefs(store);

const props = defineProps({
  settings: { type: String, required: false },
  useMockSettings: { type: String, required: false },
});

onMounted(() => {
    let appSettings = props.settings ? JSON.parse(props.settings) : null;
    if(props.useMockSettings) {
      appSettings = mockSettings;
    }

    store.initApp(appSettings);
})
        
</script>

<template>
  <div class="electrictiy-bill-calculator__container">
    <div class="electrictiy-bill-calculator__error-message" v-if="errorMessages && errorMessages.length">
      <div v-for="errorMessage in errorMessages" :key="errorMessage" v-html="errorMessage"></div>
    </div>
    <div v-if="inited">
      <div class="electrictiy-bill-calculator__wizard">
        <Step1></Step1>
        <Step2 v-if="store.showStep2"></Step2>
        <Step3 v-if="store.showStep3"></Step3>
        <Step4 v-if="store.showStep4"></Step4>
      </div>

      <Result v-if="showResults"></Result>
    </div>
  </div>
</template>

<style scoped>

</style>
